<p
	class="text-sm text-muted-foreground rounded-full border px-4 py-1 text-center w-fit mx-auto"
>
	Scenery is not affiliated with Cavalry or Scene Group
</p>
